import {useState} from 'react';
import {TextWithIcon} from '@legit.health/ui';
import {Box, Container, Rating, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import IconContainer, {customIcons} from './components/IconContainer';

const NOT_HOVERED = -1;

function NoScoringSystems() {
  const [value, setValue] = useState<number | null>(null);
  const [hover, setHover] = useState(NOT_HOVERED);
  const {t} = useTranslation(['patient/common']);

  const currentIconIndex = hover !== NOT_HOVERED ? hover : value;
  const currentIcon = currentIconIndex === null ? null : customIcons[currentIconIndex];
  return (
    <Container maxWidth="md" disableGutters>
      <Box
        component="fieldset"
        sx={{
          textAlign: 'center',
          my: 4,
          borderColor: 'transparent'
        }}
      >
        <Typography align="center" component="legend">
          {t('patient/common:diagnosticReports.form.howDoYouFeel.title')}
        </Typography>
        <Typography
          variant="h2"
          align="center"
          component="legend"
          sx={{
            mb: '16px'
          }}
        >
          {t('patient/common:diagnosticReports.form.howDoYouFeel.text')}
        </Typography>
        <Rating
          name="customized-icons"
          IconContainerComponent={IconContainer}
          sx={{
            '& .MuiSvgIcon-root': {
              fontSize: 60
            }
          }}
          size="large"
          value={value}
          onChange={(_, newValue) => setValue(newValue)}
          onChangeActive={(_, newHover) => setHover(newHover)}
        />
        {currentIcon && (
          <Box
            sx={{
              mt: 1,
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <TextWithIcon variant="h3" iconLeft={currentIcon.icon}>
              {t(`patient/common:diagnosticReports.form.howDoYouFeel.results.${currentIcon.label}`)}
            </TextWithIcon>
          </Box>
        )}
      </Box>
    </Container>
  );
}

export default NoScoringSystems;
